<template>
  <section
    class="cart-drawer-outer z12"
    :class="{ 'is-visible': visible }"
    data-mtr-section="cart"
    ref="container"
    aria-hidden="true"
  >
    <div class="cart-drawer-overlay abs fill" @click="toggle"></div>

    <div
      class="cart-drawer y x f fdc abs top right bottom bg-warm-white"
      ref="cartDrawer"
      aria-labelledby="cart-title"
      role="dialog"
      aria-modal="true"
    >
      <div class="cart-drawer__wrapper rel x f-a y">
        <div class="cart-drawer__items cart-drawer__items-container x y z6">
          <div class="rel x y">
            <div class="cart-drawer__inner abs fill f fdc y">
              <template v-if="cart.item_count > 0">
                <cart-drawer-content
                  :cart="cart"
                  :cartTitle="translations.cart.general.title"
                  :gwpAlert="translations.cart.general.gwpAlert"
                  :giftWrapCollectionImage="giftWrapCollectionImage"
                >
                </cart-drawer-content>
              </template>
              <template v-else>
                <cart-drawer-empty
                  :cart="cart"
                  :cartTitle="translations.cart.general.title"
                  :cartEmptyCopy="translations.cart.general.empty"
                  :cart-image-src="cartImageSrc"
                  :cart-image-data-src="cartImageDataSrc"
                  :cart-image-width="cartImageWidth"
                  :cart-image-height="cartImageHeight"
                  :cart-image-alt="cartImageAlt"
                ></cart-drawer-empty>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <portal-target name="cart-root"> </portal-target>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import getStoreCountryCode from "@/lib/customerLocation";
import { createFocusTrap } from "focus-trap";
import {
  checkCanFocusTrap,
  getTranslateMatrixValues,
  compensateADVisibility,
} from "@/lib/focus-trap-utils";

export default {
  name: "cart-drawer",
  data() {
    return {
      location: {},
      visible: false,
      trap: null,
    };
  },
  props: {
    cartImageSrc: String,
    cartImageDataSrc: String,
    cartImageWidth: String,
    cartImageHeight: String,
    cartImageAlt: String,
    giftWrapCollectionImage: String,
    translations: Object,
  },
  watch: {
    open(cartOpen) {
      if (cartOpen) {
        const scrollY =
          document.documentElement.style.getPropertyValue("--scroll-y");
        const body = document.body;
        body.style.position = "fixed";
        body.style.top = `-${scrollY}`;
        body.classList.add("cart-drawer--open");
        compensateADVisibility(this.$refs.container, true);
        this.visible = true;
        this.trap.activate();
      } else {
        const body = document.body;
        const scrollY = body.style.top;
        body.classList.remove("cart-drawer--open");
        body.style.position = "";
        body.style.top = "";
        compensateADVisibility(this.$refs.container, false);
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
        this.visible = false;
        this.trap.deactivate();
      }
    },
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.data,
      open: (state) => state.cart.open,
      giftFormOpen: (state) => state.cart.giftFormOpen,
    }),
  },
  methods: {
    ...mapActions({
      toggle: "cart/toggleCart",
    }),
    checkTransitionProperty(trapContainer) {
      const { x } = getTranslateMatrixValues(
        trapContainer.querySelector(".cart-drawer")
      );
      return x === "0";
    },
  },
  async created() {
    this.$store.dispatch("cart/fetchCart");
    this.$store.dispatch("metafields/fetchMeta");
    this.location = { country_code: getStoreCountryCode() };
  },
  mounted() {
    this.trap = createFocusTrap(this.$refs.container, {
      escapeDeactivates: () => this.toggle(),
      checkCanFocusTrap: (trapContainers) =>
        checkCanFocusTrap(trapContainers, this.checkTransitionProperty),
      clickOutsideDeactivates: true,
    });
  },
};
</script>
